import { memo } from "react";

// Wraps text that browser translation tools (Google Translate, Chrome) must leave untouched,
// e.g. the brand name inside a sentence. Uses both the standard `translate="no"` attribute and
// the legacy `notranslate` class so every translator honours it. Extra props go to the span.
const NoTranslate = ({ children, className = "", ...rest }) => (
    <span className={`notranslate ${className}`.trim()} translate="no" {...rest}>{children}</span>
);

export default memo(NoTranslate);
